import { UserIcon } from '@viastud/ui/shared/user-icon'
import { Mail } from 'lucide-react'

import type { ProfilePresenter } from '@/presenters/profile.presenter'
import type { ProfilePromotionalCodePresenter } from '@/presenters/profile-promotional-code.presenter'

interface ProfileCardProps {
  presenter: ProfilePresenter
  promotionalCodePresenter: ProfilePromotionalCodePresenter
}

export function ProfileCard({ presenter }: ProfileCardProps) {
  // const quizStats = presenter.getQuizStats()
  // const sheetStats = presenter.getSheetStats()

  if (!presenter.student) {
    return null
  }

  return (
    <div className="col-span-1 flex min-w-[260px] flex-col justify-between rounded-2xl bg-white p-6 shadow-lg">
      <div className="flex flex-col gap-4">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <UserIcon
              firstName={presenter.student.firstName}
              lastName={presenter.student.lastName}
            />
            <div>
              <div className="text-lg font-semibold">
                {presenter.student.firstName} {presenter.student.lastName}
              </div>
              <div className="capitalize text-gray-600">
                {presenter.onBoardingData?.grade?.toLowerCase()}
              </div>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <Mail className="h-4 w-4" /> {presenter.student.email}
        </div>
        {/* <div className="flex items-center gap-2 text-sm text-gray-600">
          <Check className="h-4 w-4 text-green-600" /> Quiz terminés : {quizStats.completed} /{' '}
          {quizStats.total}
        </div>
        <div className="flex items-center gap-2 text-sm text-gray-600">
          <Book className="h-4 w-4 text-blue-600" /> Fiches lues : {sheetStats.read} /{' '}
          {sheetStats.total}
        </div> */}
      </div>
    </div>
  )
}
